export default __webpack_public_path__ + "static/media/embedpress-icon.ca1bbd6f.svg";